import styled from 'styled-components';
import { colors, fonts } from 'stylesheets';
import { Link } from 'react-router-dom';
import bgEmpty from 'assets/img/pedidos-abertos-estado-vazio.png';


export const TitleBox = styled.p`
  font: 500 14px ${fonts.secondary};
  color: ${colors.greyDark};
  text-transform: uppercase;
`;

export const Container = styled.div`
  width: 100%;
  min-height: 600px;
  background: ${colors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  padding: 25px;
  display: ${({ flex }) => (flex ? 'flex' : 'block')};
  align-items: ${({ flex }) => (flex ? 'center' : '')};
  justify-content: ${({ flex }) => (flex ? 'center' : '')};
`;

export const TaskStyled = styled.div`
  width: 100%;
  height: 100px;
  border: 1px solid #e4e4e4;
  margin: 0 auto 11px auto;
  border-radius: 1px;
  padding: 15px 10px;
  position: relative;
  transition: box-shadow .2s;
  cursor: pointer;
  &:hover {
    box-shadow: 0 5px 10px rgba(0,0,0,.25);
    transition: box-shadow .2s;
  }
`;

export const Label = styled.span`
  font-size: 10px;
  padding: 2px 10px;
  color: ${colors.white};
  max-width: max-content;
  margin-bottom: 10px;
  margin-right: 5px;
  font-weight: 400;

  background: ${({ color }) => colors[color]};
`;

export const Labels = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: max-content;
  justify-content: flex-start;
`;

export const Name = styled.p`
  font: 500 12px ${fonts.primary};
  color: ${colors.greyDark};
  text-transform: uppercase;
  margin-bottom: 7px;
  font-weight: bold;
`;

export const Date = styled.span`
  font: 10px ${fonts.primary};
  color: #a1a1a1;
  position: absolute;
  right: 10px;
  top: 15px;
`;

export const Quotes = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const QuotesText = styled.p`
  width: max-content;
  font: 12px ${fonts.primary};
  color: ${colors.greyDark};
  margin-left: ${({ withMargin }) => (withMargin === 'margin' ? '10px' : '0px')};
`;

export const LinkStyled = styled(Link)`
  font: 12px ${fonts.primary};
  color: ${colors.primary};
  text-transform: uppercase;
  text-decoration: none;
  margin-top: 15px;
  font-weight: bold;
  float: right;
  &:hover {
    color: ${colors.primary};
    text-decoration: none;
  }
`;

export const ImageEmpty = styled.div`
  width: 247px;
  height: 168px;
  background: url(${bgEmpty}) no-repeat;
  background-size: contain;
  margin: 60px auto;
`;

export const Title = styled.div`
  font: 14px ${fonts.primary};
  font-weight: bold;
  text-transform: uppercase;
  color: ${fonts.greyDark};
  margin-top: 28px;
  text-align: center;
  margin-bottom: 15px;
`;

export const Desc = styled.div`
  font: 13px ${fonts.primary};
  color: ${fonts.greyDark};
  width: 45%;
  margin: 0 auto;
  text-align: center;
`;

export const OpenFormCta = styled.button`
  width: 162px;
  height: 34px;
  background: ${colors.white};
  border-radius: 90px;
  box-shadow: 0 2px 4px rgba(0,0,0,.25);
  text-align: center;
  line-height: 36px;
  text-transform: uppercase;
  color: ${colors.greyDark};
  cursor: pointer;
  transition: box-shadow .2s;
  font-size: 10px;
  margin: 32px auto 0 auto;
  display: block;
  border: none;
  &:hover {
    box-shadow: 0 5px 10px rgba(0,0,0,.25);
    transition: box-shadow .2s;
  }
  &:active, &:focus {
    box-shadow: 0 2px 4px rgba(0,0,0,.25);
    outline: none;
    border: none;
  }
`;
